module.exports = __webpack_public_path__ + "img/effect_3.1afe2209.jpg";